module.exports = __webpack_public_path__ + "assets/img/beeb9cb2999728b2b0789246aa9952a2.svg";